var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.8 23.2",
    style: {
      enableBackground: "new 0 0 32.8 23.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0413\\u043E\\u0442\\u0456\\u0432\\u043A\\u0430",
    transform: "translate(-195 -631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_873",
    transform: "translate(195 631)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M27,17H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h24c1.7,0,3,1.3,3,3v11C30,15.7,28.7,17,27,17z M3,1 C1.9,1,1,1.9,1,3v11c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V3c0-1.1-0.9-2-2-2H3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_147",
    transform: "translate(199 637)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M2.5,5C1.1,5,0,3.9,0,2.5S1.1,0,2.5,0S5,1.1,5,2.5S3.9,5,2.5,5z M2.5,1C1.7,1,1,1.7,1,2.5S1.7,4,2.5,4 S4,3.3,4,2.5S3.3,1,2.5,1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_149",
    transform: "translate(208 634)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M2.5,11C0.9,11,0,8.2,0,5.5S0.9,0,2.5,0S5,2.8,5,5.5S4.1,11,2.5,11z M2.5,1C1.9,1,1,2.8,1,5.5S1.9,10,2.5,10 S4,8.2,4,5.5S3.1,1,2.5,1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_148",
    transform: "translate(216 637)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M2.5,5C1.1,5,0,3.9,0,2.5S1.1,0,2.5,0S5,1.1,5,2.5S3.9,5,2.5,5z M2.5,1C1.7,1,1,1.7,1,2.5S1.7,4,2.5,4 S4,3.3,4,2.5S3.3,1,2.5,1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M224.9,651.1h-23.8c-0.9,0-1.7-0.4-2.3-1c-0.6-0.6-0.9-1.5-0.9-2.3c0-0.1,0-0.2,0-0.2l1,0.1c0,0.1,0,0.1,0,0.2 c0,0.6,0.2,1.2,0.7,1.6c0.4,0.4,1,0.7,1.6,0.7h23.8c0.6,0,1-0.2,1.4-0.5c0.6-0.7,0.6-1.8,0.6-1.8v-10.5c0-0.2,0-0.3,0-0.5 c-0.1-0.5-0.3-1-0.7-1.4c-0.4-0.3-0.9-0.5-1.5-0.4l-0.1-1c0.8-0.1,1.6,0.1,2.2,0.7c0.6,0.5,1,1.2,1.1,2c0,0.2,0,0.4,0,0.6l0,10.5 c0,0,0,1.5-0.9,2.5C226.4,650.8,225.7,651.1,224.9,651.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M223.1,654.2H199c-1.1,0-3.3-0.6-3.3-3v-4.5h1v4.5c0,1.9,2,2,2.3,2h24.1c0.5,0,0.9-0.2,1.2-0.5 c0.7-0.7,0.6-2.1,0.6-2.1l1-0.1c0,0.1,0.2,1.8-0.8,2.9C224.6,653.9,223.9,654.2,223.1,654.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.95afcb92a68907c051eb21d1162e12c5.svg";
export { ForwardRef as ReactComponent };